// product name
export const PRODUCT = 'home';

// responsive queries and width constants
export const MOBILE_WIDTH = 768;
export const MEDIUM_WIDTH = 1024;
export const LARGE_WIDTH = 1280;
export const EXTRA_LARGE_WIDTH = 1440;
// uses latest recess breakpoints for medium width
export const NEW_MAX_TABLET_WIDTH = 958;
// used specifically to implement mobile stepper 1px smaller than standard iPad width
// allows single column mobile view without adding desktop style stepper
export const STEPPER_MOBILE_WIDTH = 767;

export const MOBILE_QUERY = Object.freeze({ query: `(max-width: ${MOBILE_WIDTH}px)` });
export const MEDIUM_QUERY = Object.freeze({ query: `(max-width: ${MEDIUM_WIDTH}px)` });
export const NEW_MAX_TABLET_QUERY = Object.freeze({
  query: `(max-width: ${NEW_MAX_TABLET_WIDTH}px)`,
});
export const LARGE_QUERY = Object.freeze({ query: `(max-width: ${LARGE_WIDTH}px)` });
export const EXTRA_LARGE_QUERY = Object.freeze({ query: `(max-width: ${EXTRA_LARGE_WIDTH}px)` });
export const MOBILE_STEPPER_QUERY = Object.freeze({
  query: `(max-width: ${STEPPER_MOBILE_WIDTH}px)`,
});

// custom media query that allows buttons on the student loan card to align properly
export const STUDENT_LOAN_CARD_QUERY = Object.freeze({ query: '(max-width: 1361px)' });

// validation patterns
export const PHONE_REGEX = /^\({1}\d{3}\){1}\s{1}\d{3}-{1}\d{4}$/;

// environment URLs
export const APPLICATIONS_URL =
  process.env.REACT_APP_APPLICATIONS_URL || 'https://applications.guildeducation.com';
export const BENEFITS_BASE_URL =
  process.env.REACT_APP_BENEFITS_BASE_URL || 'https://benefits.guildeducation.com';
export const BENEFIT_OVERVIEW_URL =
  process.env.REACT_APP_BENEFIT_OVERVIEW_URL ||
  'https://benefits.guildeducation.com/find-your-plan';
export const BENEFIT_ELIGIBILITY_URL =
  process.env.REACT_APP_BENEFIT_ELIGIBILITY_URL ||
  'https://benefits.guildeducation.com/eligibility';
export const CATALOG_URL =
  process.env.REACT_APP_CATALOG_URL ?? 'https://catalog.guildeducation.com';
export const CATALOG_SERVICE_URL =
  process.env.REACT_APP_CATALOG_SERVICE_URL ?? 'https://catalog-appsync.guild-cloud.com';
export const FIND_FUNDING_URL =
  process.env.REACT_APP_FIND_FUNDING_URL ||
  'https://apply.guildeducation.com/find-funding?referrer=home';
export const GENESIS_URL = process.env.REACT_APP_GENESIS_URL || 'https://apply.guildeducation.com';
export const GUILD_URL = process.env.REACT_APP_GUILD_URL || 'https://students.guildeducation.com';
export const MEMBER_TRAIT_SERVICE_URL =
  process.env.REACT_APP_MEMBER_TRAIT_SERVICE_URL || 'https://member-traits.guildeducation.com';
export const PROFILE_COMPLETION_URL = process.env.REACT_APP_PROFILE_COMPLETION_URL;
export const PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL || 'https://home.guildeducation.com';
export const SELF_REPORTED_DATA_SERVICE_URL = process.env.REACT_APP_SELF_REPORTED_DATA_SERVICE_URL;
export const TUITION_REIMBURSEMENT_URL =
  process.env.REACT_APP_TUITION_REIMBURSEMENT_URL || 'https://reimbursement.guildeducation.com';
export const VERIFICATION_URL = process.env.REACT_APP_VERIFICATION_URL;
export const VIDEOS_URL = 'https://videos.guildeducation.com';

// applications destination paths
export const APPLY_PATH = 'apply';
export const APPLICATION_PATH = 'applications';

// benefits destination paths
export const DIRECT_PAYMENT_PATH = 'how-it-works#sponsorship-partial-funding';
export const PARTIAL_FUNDING_PATH = 'how-it-works#tuition-reimbursement-partial-funding';

// catalog destination paths
export const CATALOG_BOOKMARKS_PATH = 'bookmarks';
export const CATALOG_RECOMMENDATIONS_PATH = 'recommended';
export const CATALOG_QUIZ_PATH = 'quiz';

// partner page destination paths
export const DISNEY_MANAGER_TOOLKIT_PATH = '/partner/manager_toolkit';
export const PARTNER_PAGES_PATH = '/partner';
export const PARTNER_PAGES_OVERVIEW_PATH = '/partner/overview';

// users destination paths
export const USER_EDIT_PATH = '/user_edit';
export const PROGRAM_COMPLETION_DATES_PATH = 'program-completion-dates';
export const COMPLETED_PROGRAMS_SECTION_ID = 'completed-programs';

// external URLs
export const STUDENT_LOAN_SSO_URL =
  process.env.REACT_APP_STUDENT_LOAN_SSO_URL || 'https://api.getcandidly.com/saml/guild/login';
export const SALESFORCE_URL = 'https://help.guildeducation.com';
export const SALESFORCE_NEW_REQUEST_URL = 'https://supportform.guildeducation.com';

// programs and applications default subtext
export const PA_DEFAULT_SUBTEXT =
  "You've got learning options! Explore our catalog of programs, get recommendations, and manage your applications.";

// state search url for autocomplete
export const STATE_SEARCH_URL =
  'https://ottercomplete-cloud.guildeducation.com/search/states?query={{value}}';

// url for sponsorship
export const SPONSORSHIP_URL =
  process.env.REACT_APP_SPONSORSHIP_URL || 'http://sponsorship.guildeducation.com';

// url for career accelerator
export const CAREER_ACCELERATOR_URL =
  process.env.REACT_APP_CAREER_ACCELERATOR_URL ||
  'https://career.guildeducation.com/career-accelerator';

export const CAREER_PATHWAY_URL =
  process.env.REACT_APP_CAREER_PATHWAY_URL || 'https://career.guildeducation.com/pathway';

// program types
export const PROGRAM_TYPES = [
  { label: 'Advanced Certificate', value: 'advanced_certificate' },
  { label: 'Associate of Arts Degree', value: 'associate_of_arts_degree' },
  { label: 'Associate of Science Degree', value: 'associate_of_science_degree' },
  { label: 'Bachelor of Applied Science', value: 'bachelor_of_applied_science' },
  { label: 'Bachelor of Arts Degree', value: 'bachelor_of_arts_degree' },
  { label: 'Bachelor of Business Administration', value: 'bachelor_of_business_administration' },
  { label: 'Bachelor of General Studies', value: 'bachelor_of_general_studies' },
  {
    label: 'Bachelor of Professional Service Degree',
    value: 'bachelor_of_professional_service_degree',
  },
  { label: 'Bachelor of Science Degree', value: 'bachelor_of_science_degree' },
  { label: 'Certificate', value: 'certificate' },
  { label: 'College Prep', value: 'college_prep' },
  { label: 'Doctor of Nursing Practice', value: 'doctor_of_nursing_practice' },
  { label: 'Doctor of Physical Therapy', value: 'doctor_of_physical_therapy' },
  { label: 'High School', value: 'high_school' },
  { label: 'Intermediate Certificate', value: 'intermediate_certificate' },
  { label: 'Introductory Certificate', value: 'introductory_certificate' },
  { label: 'Language', value: 'language' },
  { label: 'Master of Arts Degree', value: 'master_of_arts_degree' },
  { label: 'Master of Business Administration', value: 'master_of_business_administration' },
  { label: 'Master of Healthcare Administration', value: 'master_of_healthcare_administration' },
  { label: 'Master of Public Administration', value: 'master_of_public_administration' },
  { label: 'Master of Science Degree', value: 'master_of_science_degree' },
  { label: 'Professional Development', value: 'professional_development' },
  { label: 'Not found', value: 'not_found' },
];

// career accelerator and resources copy
export const FULL_CAREER_RESOURCES_BODY =
  'Explore job openings, and learn how to unlock your next career opportunity.';
export const CAREER_ACCELERATOR_ONLY_BODY = 'Learn how to unlock your next career opportunity.';
export const CAREER_TOPIC_PAGES_ONLY_BODY =
  'Explore job openings and unlock your next career opportunity.';
export const JOB_POSTINGS_LABEL =
  'Remember, don’t be discouraged reading job descriptions if you aren’t 100% qualified. You can still apply!';

// ECornell APID
export const ECORNELL_ACADEMIC_PARTNER_ID = '3ce34f6c-6fb2-4d39-b029-f8f40717df62';

export const USOPC_EMPLOYER_UUID = '95956f1a-1cae-4848-8756-b494a2511827';
